import { Nullable } from "@/api/ApiClient";

export type InvoiceTemplateFormData = Nullable<{
    id: string,
    numero: number,
    title: string,
    activa: boolean,
    exenta: boolean,
    porcenta_descuento: number,
    subtotal: number,
    descuento: number,
    impuestos: number,
    total: number,
    otros_cargos: string,
    exchange_rate: number,
    currencyId: string,
    currency: any,
    invoiceTemplateProducts: any[],
}>

export const InvoiceTemplateRelatedAttributes: Array<keyof InvoiceTemplateFormData> = ["currency", "invoiceTemplateProducts"];